//全局getters
import state from "./state";

const getters = {
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js